@if (items().length > 0) {
  <div class="sav-product-grid">
    @for (product of items(); track product.id || product.title + product.storeName) {
      <!-- `productId` and `detailPath` are what give the card its "Buy Now | View Detail" row:
           Buy Now leaves through the /go/p/:id redirect, View Detail opens the product
           page. Without them the grid rendered a card with no actions. -->
      <app-product-card
        [title]="product.title"
        [image]="product.imageUrl"
        [hoverImage]="product.hoverImageUrl"
        [storeName]="product.storeName"
        [storeLogoUrl]="product.storeLogoUrl"
        [price]="product.price"
        [oldPrice]="product.oldPrice"
        [href]="product.storePath"
        [external]="product.isExternal"
        [detailHref]="product.detailPath"
        [productId]="product.id"
      />
    }
  </div>
}
